import dayjs from 'dayjs';
import { UploadRunStatus, UploadStatusType } from './csv-uploader-status';

export const UPLOAD_STATUS_STORAGE_KEY = 'fileUploadStatus';

interface NewUploadStatus {
  workflowId: string;
  fileName: string;
  fileLink: string;
  fileType: string;
}

// Check Status reads this list, so the entry has to be written where the task
// ID arrives rather than in a render effect.
//
// Storage errors are caught here. The upload is finished on the server by the
// time this runs, so a browser that refuses the write must not make the upload
// look like it failed.
export const appendUploadStatus = (entry: NewUploadStatus): void => {
  try {
    const uploadStatus: UploadStatusType[] = JSON.parse(
      localStorage.getItem(UPLOAD_STATUS_STORAGE_KEY) || '[]',
    );

    const alreadyExists = uploadStatus.some(
      existing => existing.workflowId === entry.workflowId,
    );

    if (alreadyExists) {
      return;
    }

    uploadStatus.push({
      ...entry,
      uploadedAt: dayjs().format('L LT'),
      status: UploadRunStatus.RUNNING,
      failureMessage: null,
    });

    localStorage.setItem(
      UPLOAD_STATUS_STORAGE_KEY,
      JSON.stringify(uploadStatus),
    );
  } catch (error) {
    console.error('Could not save the upload to Check Status:', error);
  }
};
